import home from './home'
import purchase from './purchase'
import warehouse from './warehouse'
import order from './order'
import goods from './goods'
import purchaseAdvise from './purchase-advise'
import layout from './layout'
import refund from './refund'
import time from './time'
import finance from './finance'
import setting from './setting'
import base from './base'
export default {
  home,
  purchase,
  warehouse,
  order,
  goods,
  purchaseAdvise,
  layout,
  refund,
  time,
  setting,
  finance,
  base,
}
